import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TRACKING } from '../../bdo/enums/trackingParts.enum';
import { TrackingService } from '../../bdo/services/tracking.service';
import { ReBaseData } from '../../shared/utils/re-base-data';

@Component({
    selector: 'bdo-loginpage',
    templateUrl: './loginpage.component.html',
    styleUrls: ['./loginpage.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginpageComponent {
  public TRACKING = TRACKING;
  protected reBaseData = ReBaseData;

  constructor(
    public trackingService: TrackingService
  ) { }

}
